import { PostalInfo } from "./../API";
import API, { GraphQLResult } from "@aws-amplify/api";
import { mutation, query } from "gql-query-builder";
import { buildVariables } from "../libs/GraphQueryBuilder";
import {
  ByEmailQueryVariables,
  CompanyRole,
  CompanyStatus,
  CreateCompanyDomainMutationVariables,
  CreateCompanyInput,
  CreateCompanyMutationVariables,
  CreateCompanyUserInput,
  CreateCompanyUserMutationVariables,
  CreateProxyPollMutationVariables,
  CreateRequestJoinCompanyInput,
  CreateRequestJoinCompanyMutationVariables,
  CreateUserInput,
  CreateUserMutationVariables,
  DeleteCompanyDomainMutationVariables,
  DeleteCompanyUserMutationVariables,
  GetCompanyQueryVariables,
  GetRequestJoinCompanyQueryVariables,
  GetUserByUsernameQueryVariables,
  GetUserQueryVariables,
  ListCompaniesByOwnerQueryVariables,
  ListCompanyDomainByCompanyIDQueryVariables,
  ListCompanyRolesByAdminQueryVariables,
  ListCompanyRolesByCompanyQueryVariables,
  ListCompanyRolesByUserQueryVariables,
  ListProxyPollsByPollIDQueryVariables,
  ListRequestJoinCompanyByCompanyIDQueryVariables,
  ListStripeAccountsByUserQueryVariables,
  RequestJoinCompanyStatus,
  UpdateCompanyDomainMutationVariables,
  UpdateProxyPollMutationVariables,
  UpdateRequestJoinCompanyMutationVariables,
  UpdateUserInput,
  UpdateUserMutationVariables,
  User,
  UserType,
  UpdateCompanyMutationVariables,
  UpdateCompanyInput,
  ListUsersQueryVariables,
  UpdateCompanyUserMutationVariables,
  UserSalaryRange,
  CreateCompanyThemeInput,
  CreateCompanyThemeMutationVariables,
  ListCompanyThemesByCompanyIDQueryVariables,
  UpdateCompanyThemeInput,
  UpdateCompanyThemeMutationVariables,
  GetGuestMutationVariables
} from "../API";
import {
  CreateProxiedUserInput,
  CreateProxiedUserMutationVariables,
} from "../API-extended";

// Record<GRC, Divison[]>
export const LOCATION_LIST = {
  "Jalan Besar": [
    "KAMPONG GLAM (KG)",
    "KOLAM AYER (KY)",
    "WHAMPOA (WH)",
    "KRETA AYER - KIM SENG (KK)",
  ],
};

export type UserAttributes = {
  yearOfBirthRange?: {
    from: number;
    to: number;
  };
  salaryRange?: UserSalaryRange[];
  gender?: string[];
  education?: string[];
  location?: {
    division?: string[];
    grc?: string[];
  };
};

export async function searchUsers(input: UserAttributes) {
  const yearOfBirth = input.yearOfBirthRange
    ? {
        yearOfBirth: {
          ge: input.yearOfBirthRange?.from,
          le: input.yearOfBirthRange?.to,
        },
      }
    : {};
  const salaryRange = input.salaryRange
    ? {
        or: input.salaryRange.map((value) => {
          return {
            salaryRange: {
              eq: value,
            },
          };
        }),
      }
    : {};
  const gender = input.gender
    ? {
        or: input.gender.map((value) => {
          return {
            gender: {
              eq: value,
            },
          };
        }),
      }
    : {};
  const education = input.education
    ? {
        or: input.education.map((value) => {
          return {
            education: {
              eq: value,
            },
          };
        }),
      }
    : {};

  // remove empty
  let filters = [yearOfBirth, education, gender, salaryRange];
  filters = filters.filter(
    (_, index) => Object.keys(filters[index]).length > 0
  );

  let _token = {};
  let filter: any = {
    filter: {
      and: filters,
    },
  };
  filter = Object.keys(filter.filter).length !== 0 ? filter : {};

  console.log(filter);
  const result: any[] = [];
  do {
    const _variables: ListUsersQueryVariables = {
      ...filter,
      ..._token,
    };
    const variables = buildVariables<ListUsersQueryVariables>(_variables, [
      { key: "filter", name: "ModelUserFilterInput" },
    ]);
    const q = query({
      operation: "result: listUsers",
      fields: [
        { items: ["id", { postalInfo: ["division", "grc"] }] },
        "nextToken",
      ],
      variables,
    });
    const _result: any = await API.graphql(q);
    const items: any[] = _result?.data?.result?.items;
    result.push(...items);
    _token =
      _result.data.result.nextToken != null
        ? {
            nextToken: _result.data.result.nextToken,
          }
        : {};
  } while (Object.keys(_token).length !== 0);

  if (input.location != undefined) {
    return result.filter((user) => {
      if (!user.postalInfo) return false;
      if (input.location?.grc) {
        if (!input.location.grc.includes(user.postalInfo.grc)) {
          return false;
        }
      }

      if (input.location?.division) {
        if (!input.location.division.includes(user.postalInfo.division)) {
          return false;
        }
      }
      return true;
    });
  } else {
    return result;
  }
}
export function getCompany(companyID) {
  const _variables: GetCompanyQueryVariables = {
    id: companyID,
  };
  const variables = buildVariables(_variables, [{ key: "id", name: "ID!" }]);
  const q = query({
    operation: "result: getCompany",
    fields: ["name", "domain"],
    variables,
  });
  return API.graphql(q);
}

export async function getCompanyByUserID(userID) {
  const companyUserRes: any = await getCompanyUserByUser(userID);
  if ((companyUserRes.data?.result?.items.length || 0) === 0) {
    return undefined;
  }

  const companyUser =
    companyUserRes.data.result.items[
      companyUserRes.data.result.items.length - 1
    ];
  const companyRes: any = await getCompany(companyUser.companyID);
  const company = companyRes.data?.result;
  return {
    id: companyUser.companyID,
    companyID: companyUser.companyID,
    ...company,
    ...companyUser,
  } as {
    name: string;
    companyID: string;
    domain: string;
    adminID: string;
    id: string;
    role: CompanyRole;
  };
}

export function companyRegisterDomain(companyID: string, domain: string) {
  const _variables: CreateCompanyDomainMutationVariables = {
    input: {
      companyID,
      domain,
    },
  };
  const variables = buildVariables<CreateCompanyDomainMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateCompanyDomainInput!" }]
  );
  const q = mutation({
    operation: "result: createCompanyDomain",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}
export function listDomainByCompany(companyID: string) {
  const _variables: ListCompanyDomainByCompanyIDQueryVariables = {
    companyID,
  };
  const variables = buildVariables<ListCompanyDomainByCompanyIDQueryVariables>(
    _variables,
    [{ key: "companyID", name: "ID!" }]
  );
  const q = query({
    operation: "result: listCompanyDomainByCompanyID",
    fields: [{ items: ["id", "domain", "createdAt"] }],
    variables,
  });
  return API.graphql(q);
}

export function removeDomain(domainID: string) {
  const _variables: DeleteCompanyDomainMutationVariables = {
    input: {
      id: domainID,
    },
  };
  const variables = buildVariables<DeleteCompanyDomainMutationVariables>(
    _variables,
    [{ name: "input", key: "DeleteCompanyDomainInput!" }]
  );
  const q = mutation({
    operation: "result: deleteCompanyDomain",
    fields: [],
    variables,
  });
  return API.graphql(q);
}

export function updateDomain(domainID: string, newDomain: string) {
  const _variables: UpdateCompanyDomainMutationVariables = {
    input: {
      id: domainID,
      domain: newDomain,
    },
  };
  const variables = buildVariables<UpdateCompanyDomainMutationVariables>(
    _variables,
    [{ name: "input", key: "UpdateCompanyDomainMutation!" }]
  );
  const q = mutation({
    operation: "result: updateCompanyDomain",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export async function joinCompany(userID: string, companyID: string) {
  const domains: any = await listDomainByCompany(companyID);
  console.log("listCompanyUsers", companyID, CompanyRole.ADMIN);
  const admin: any = await listCompanyUsers(companyID, CompanyRole.ADMIN);
  console.log("admin", admin);
  if ((admin.data?.result?.items?.length || 0) === 0) {
    throw new Error("Company does not exists, please contact company admin");
  }
  const { adminID } = admin.data?.result?.items[0];
  const user: any = await getUser(["username", "email"], userID);
  const { username, email } = user.data?.result;
  const userDomain = email.split("@")[1];
  const found = domains.data?.result?.items.find((d) => d.domain == userDomain);
  if (found) {
    return createCompanyRole({
      userID,
      owner: username,
      username,
      companyID,
      adminID,
      role: CompanyRole.EMPLOYEE,
    });
  } else {
    return requestJoinCompany({
      userID,
      companyID,
    });
  }
}

function getStripeAccountByUserID(userID: string) {
  const _variables: ListStripeAccountsByUserQueryVariables = {
    userID,
  };
  const variables = buildVariables<ListStripeAccountsByUserQueryVariables>(
    _variables,
    []
  );
  const q = query({
    operation: "result: listStripeAccountsByUser",
    fields: [{ items: ["id", "userID", "isOnboard", "createdAt", "owner"] }],
    variables,
  });
  return API.graphql(q);
}

export async function getUser(fields: any[], userID: string) {
  const _variables: GetUserQueryVariables = {
    id: userID,
  };
  const variables = buildVariables<GetUserQueryVariables>(_variables, [
    { key: "id", name: "ID!" },
  ]);
  const q = query({
    operation: "result: getUser",
    fields,
    variables,
  });
  return API.graphql(q);
}

export async function getPaymentMethod(userID: string) {
  const res: any = {};
  res["stripe"] = await getStripeAccountByUserID(userID);
  return res;
}

export async function listRepresentativeByCompany(companyID: string) {
  const _variables: ListCompanyRolesByCompanyQueryVariables = {
    companyID,
  };

  const variables = buildVariables<ListCompanyRolesByCompanyQueryVariables>(
    _variables,
    [{ key: "companyID", name: "ID!" }]
  );
  const q = query({
    operation: "result: listCompanyRolesByCompany",
    fields: [
      {
        items: [
          "id",
          "companyID",
          "userID",
          {
            user: [
              "email",
              "phone",
              "firstName",
              "lastName",
              "username",
              "yearOfBirth",
              "gender",
            ],
          },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function listRepresentativeByAdmin(adminID: string) {
  const _variables: ListCompanyRolesByAdminQueryVariables = {
    adminID,
  };

  const variables = buildVariables<ListCompanyRolesByAdminQueryVariables>(
    _variables,
    [{ key: "adminID", name: "ID!" }]
  );
  const q = query({
    operation: "result: listCompanyRolesByAdmin",
    fields: [
      {
        items: [
          "id",
          "companyID",
          "userID",
          {
            user: [
              "email",
              "phone",
              "firstName",
              "lastName",
              "username",
              "yearOfBirth",
              "gender",
            ],
          },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function listCompanyUsers(companyID: string, role?: CompanyRole) {
  const _variables: ListCompanyRolesByCompanyQueryVariables = {
    companyID,
  };
  if (role) {
    _variables.filter = {
      role: { eq: role },
    };
  }

  const variables = buildVariables<ListCompanyRolesByCompanyQueryVariables>(
    _variables,
    [
      { key: "companyID", name: "ID!" },
      { key: "filter", name: "ModelCompanyUserFilterInput" },
      { key: "role", name: "ModelCompanyRoleInput" },
    ]
  );
  const q = query({
    operation: "result: listCompanyRolesByCompany",
    fields: [
      {
        items: [
          "id",
          "companyID",
          "adminID",
          "userID",
          "role",
          {
            user: [
              "email",
              "phone",
              "firstName",
              "lastName",
              "username",
              "yearOfBirth",
              "gender",
            ],
          },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function getCompanyUserByUser(userID: string) {
  const _variables: ListCompanyRolesByUserQueryVariables = {
    userID,
  };
  const variables = buildVariables<ListCompanyRolesByUserQueryVariables>(
    _variables,
    [{ key: "userID", name: "ID!" }]
  );
  const q = query({
    operation: "result: listCompanyRolesByUser",
    fields: [{ items: ["adminID", "id", "companyID", "role", "owner"] }],
    variables,
  });
  return API.graphql(q);
}

export function createCompanyRole(input: CreateCompanyUserInput) {
  const _variables: CreateCompanyUserMutationVariables = {
    input,
  };

  const variables = buildVariables<CreateCompanyUserMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateCompanyUserInput!" }]
  );

  const q = mutation({
    operation: "result: createCompanyUser",
    fields: ["id", "companyID"],
    variables,
  });
  return API.graphql(q);
}

export function createCompanyTheme(input: CreateCompanyThemeInput) {
  const _variables: CreateCompanyThemeMutationVariables = {
    input,
  };

  const variables = buildVariables<CreateCompanyThemeMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateCompanyThemeInput!" }]
  );

  const q = mutation({
    operation: "result: createCompanyTheme",
    fields: [
      "id",
      "companyID",
      {
        attributes: [
          "pollActivePeriodBgColor",
          "pollActivePeriodShadowColor",
          "pollQuestionCardBgColor",
          "pollQuestionCardQuestionColor",
          "pollQuestionCardAnswerColor",
          "pollPledgeCastBtnBgColor",
          "pollPledgeCastBtnBracketColor",
          "pollPledgeCastBtnTextColor",
          "pollPageBgColor",
        ],
      },
      "owner",
    ],
    variables,
  });
  return API.graphql(q);
}

export async function createCompanyCustomTheme(input: CreateCompanyThemeInput) {
  let customTheme: any = await createCompanyTheme(input);
  return customTheme;
}

export function updateCompanyTheme(input: UpdateCompanyThemeInput) {
  const _variables: UpdateCompanyThemeMutationVariables = {
    input,
  };

  const variables = buildVariables<UpdateCompanyThemeMutationVariables>(
    _variables,
    [{ key: "input", name: "UpdateCompanyThemeInput!" }]
  );

  const q = mutation({
    operation: "result: updateCompanyTheme",
    fields: [
      "id",
      "companyID",
      {
        attributes: [
          "pollActivePeriodBgColor",
          "pollActivePeriodShadowColor",
          "pollQuestionCardBgColor",
          "pollQuestionCardQuestionColor",
          "pollQuestionCardAnswerColor",
          "pollPledgeCastBtnBgColor",
          "pollPledgeCastBtnBracketColor",
          "pollPledgeCastBtnTextColor",
          "pollPageBgColor",
        ],
      },
      "owner",
    ],
    variables,
  });
  return API.graphql(q);
}

export async function updateCompanyCustomTheme(input: UpdateCompanyThemeInput) {
  let customTheme: any = await updateCompanyTheme(input);
  return customTheme;
}

export async function listCompanyThemesByCompanyId(companyID: string) {
  const _variables: ListCompanyThemesByCompanyIDQueryVariables = {
    companyID,
  };
  const variables = buildVariables<ListCompanyThemesByCompanyIDQueryVariables>(
    _variables,
    [{ key: "companyID", name: "ID!" }]
  );

  const q = query({
    operation: "result: listCompanyThemesByCompanyID",
    fields: [
      {
        items: [
          "id",
          "companyID",
          {
            attributes: [
              "pollActivePeriodBgColor",
              "pollActivePeriodShadowColor",
              "pollQuestionCardBgColor",
              "pollQuestionCardQuestionColor",
              "pollQuestionCardAnswerColor",
              "pollPledgeCastBtnBgColor",
              "pollPledgeCastBtnBracketColor",
              "pollPledgeCastBtnTextColor",
              "pollPageBgColor",
            ],
          },
          "owner",
        ],
      },
    ],
    variables,
  });

  return API.graphql(q);
}

export async function getCompanyThemesByCompanyID(companyID) {
  const res: any = await listCompanyThemesByCompanyId(companyID);
  return res;
}

export async function createCompanyProfile(
  userID: string,
  username: string,
  input: CreateCompanyInput
) {
  input.owner = username;
  input.status = CompanyStatus.DEACTIVATED;
  let comp: any = await createCompany(input);
  let companyID = comp.data.result.id;
  await updateUser(userID, { company: input.name });
  return createCompanyRole({
    owner: username,
    username,
    userID,
    companyID,
    adminID: userID,
    role: CompanyRole.ADMIN,
  });
}

export async function getCompanyByOwner(owner: string) {
  const _variables: ListCompaniesByOwnerQueryVariables = {
    owner,
  };
  const variables = buildVariables<ListCompaniesByOwnerQueryVariables>(
    _variables,
    []
  );

  const q = query({
    operation: "result: listCompaniesByOwner",
    fields: [{ items: ["id", "name"] }],
    variables,
  });

  return API.graphql(q);
}

export async function assignRepresentative(
  representativeEmail: string,
  companyId: string,
  userId: string
) {
  const user: any = await getUserByEmail(
    [{ items: ["id", "username"] }],
    representativeEmail
  );
  if (!user.data.result.items[0]) throw new Error("No user found with email.");
  let representativeId = user.data.result.items[0]?.id;
  let representativeUsername = user.data.result.items[0]?.username;
  // await updateUser(userID, {type: UserType.REPRESENTATIVE});
  return createCompanyRole({
    id: representativeId,
    owner: representativeUsername,
    username: representativeUsername,
    userID: representativeId,
    companyID: companyId,
    adminID: userId,
    role: CompanyRole.REPRESENTATIVE,
  });
}

export function assignProxyPoll(proxyUserID: string, pollID: string) {
  const _variables: CreateProxyPollMutationVariables = {
    input: {
      proxyUserID,
      pollID,
      enabled: true,
    },
  };

  const variables = buildVariables<CreateProxyPollMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateProxyPollInput!" }]
  );

  const q = mutation({
    operation: "result: createProxyPoll",
    fields: ["id"],
    variables,
  });

  return API.graphql(q);
}

export async function unassignProxyPoll(proxyUserID: string, pollID: string) {
  const id: string = await checkProxyHandlePoll(proxyUserID, pollID);
  const _variables: UpdateProxyPollMutationVariables = {
    input: {
      id,
      enabled: false,
    },
  };

  const variables = buildVariables<UpdateProxyPollMutationVariables>(
    _variables,
    [{ key: "input", name: "UpdateProxyPollInput!" }]
  );

  const q = mutation({
    operation: "result: updateProxyPoll",
    fields: ["id"],
    variables,
  });

  return API.graphql(q);
}

export function listProxiesByPoll(pollID: string, userFields: any[]) {
  const _variables: ListProxyPollsByPollIDQueryVariables = {
    pollID,
    filter: {
      enabled: { eq: true },
    },
  };
  const variables = buildVariables<ListProxyPollsByPollIDQueryVariables>(
    _variables,
    [
      { key: "pollID", name: "ID!" },
      { key: "filter", name: "ModelProxyPollFilterInput" },
    ]
  );
  const q = query({
    operation: "result: listProxyPollsByPollID",
    fields: [
      {
        items: [{ user: userFields }],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function proxyCreateUser(
  proxyUserID: string,
  userInput: CreateProxiedUserInput
) {
  const proxy: any = await getUserByID(["owner"], proxyUserID);
  if (proxy.data?.result === undefined) {
    throw new Error("proxy does not exist");
  }

  userInput.owner = proxy.data?.result?.owner;

  const query = createProxiedUserOperation(userInput);
  return API.graphql(query);
}

export async function checkProxyHandleUser(
  proxyUserID: string,
  userID: string
) {
  const userRes = (await getUserByID(
    ["proxyUserID"],
    userID
  )) as GraphQLResult<{ result: User }>;
  const user = userRes.data?.result;
  if (!user) {
    return false;
  }

  if (user.proxyUserID !== proxyUserID) {
    return false;
  }

  return true;
}

export async function checkProxyHandlePoll(
  proxyUserID: string,
  pollID: string
) {
  const _variables: ListProxyPollsByPollIDQueryVariables = {
    pollID,
    filter: {
      enabled: { eq: true },
      proxyUserID: { eq: proxyUserID },
    },
  };
  const variables = buildVariables<ListProxyPollsByPollIDQueryVariables>(
    _variables,
    [
      { key: "pollID", name: "ID!" },
      { key: "filter", name: "ModelProxyPollFilterInput" },
    ]
  );
  const q = query({
    operation: "result: listProxyPollsByPollID",
    fields: [{ items: ["id"] }],
    variables,
  });
  const res: any = await API.graphql(q);
  if (res.data?.result?.items.length > 0) {
    return res.data?.result?.items[0].id;
  } else {
    return undefined;
  }
}

export async function assignCompanyUser(
  role: CompanyRole,
  userEmail: string,
  companyID: string,
  adminID: string
) {
  const users: any =
    (
      (await getUserByEmail(
        [{ items: ["id", "username"] }],
        userEmail
      )) as GraphQLResult<{ result: any }>
    ).data?.result?.items || [];

  let user;
  if (users.length > 0) {
    user = users[0];
  } else if (users.length === 0 && role === CompanyRole.PROXY) {
    user = (
      (await proxyCreateUser(adminID, {
        username: userEmail,
        email: userEmail,
        company: companyID,
        proxyUserID: adminID,
      })) as GraphQLResult<{ result: any }>
    ).data?.result;
  }

  if (!user) {
    throw new Error("No user found with email.");
  }

  let { id, username } = user;

  return createCompanyRole({
    id,
    userID: id,
    owner: username,
    username,
    companyID,
    adminID,
    role,
  });
}

function getCompanyUserByAdmin(companyID, userID, adminID) {
  const _variables: ListCompanyRolesByAdminQueryVariables = {
    adminID,
    filter: {
      userID: { eq: userID },
      companyID: { eq: companyID },
    },
  };

  const variables = buildVariables<ListCompanyRolesByAdminQueryVariables>(
    _variables,
    [
      { key: "adminID", name: "ID!" },
      { key: "filter", name: "ModelCompanyUserFilterInput" },
    ]
  );
  const q = query({
    operation: "result: listCompanyRolesByAdmin",
    fields: [{ items: ["id"] }],
    variables,
  });
  return API.graphql(q);
}

export async function updateCompanyUserRole(id: string, role: CompanyRole) {
  const _variables: UpdateCompanyUserMutationVariables = {
    input: {
      id,
      role,
    },
  };
  const variables = buildVariables<UpdateCompanyUserMutationVariables>(
    _variables,
    [{ key: "input", name: "UpdateCompanyUserInput!" }]
  );
  const q = mutation({
    operation: "result: updateCompanyUser",
    fields: ["userID"],
    variables,
  });

  return API.graphql(q);
}

export async function deleteCompanyUser(id: string) {
  const _variables: DeleteCompanyUserMutationVariables = {
    input: {
      id,
    },
  };
  const variables = buildVariables<DeleteCompanyUserMutationVariables>(
    _variables,
    [{ key: "input", name: "DeleteCompanyUserInput!" }]
  );
  const q = mutation({
    operation: "result: deleteCompanyUser",
    fields: ["userID"],
    variables,
  });

  return API.graphql(q);
}

export async function unassignRepresentative(roleId: string) {
  return deleteCompanyUser(roleId);
}

export async function unassignCompanyUser(roleId: string) {
  return deleteCompanyUser(roleId);
}

export function getUserByEmail(fields: any[], email: string) {
  const _variables: ByEmailQueryVariables = {
    email,
  };
  const query = getUserByEmailQuery(fields, _variables);
  return API.graphql(query);
}

export async function getUserByUsername(fields: any[], username: string) {
  const _variables: GetUserByUsernameQueryVariables = {
    username,
  };
  const query = getUserByUsernameQuery(fields, _variables);
  return API.graphql(query);
}

function createUserOperation(input: CreateUserInput) {
  const _variables: CreateUserMutationVariables = {
    input,
  };

  const variables = buildVariables<CreateUserMutationVariables>(_variables, [
    { key: "input", name: "CreateUserInput!" },
  ]);

  return mutation({
    operation: "result: createUser",
    fields: ["id", "username", "owner"],
    variables,
  });
}

function createProxiedUserOperation(input: CreateProxiedUserInput) {
  const _variables: CreateProxiedUserMutationVariables = {
    input,
  };

  const variables = buildVariables<CreateProxiedUserMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateUserInput!" }]
  );

  return mutation({
    operation: "result: createUser",
    fields: ["id", "username", "owner"],
    variables,
  });
}

export function updateCompany(input: UpdateCompanyInput) {
  const _variables: UpdateCompanyMutationVariables = {
    input,
  };

  const variables = buildVariables<UpdateCompanyMutationVariables>(_variables, [
    { key: "input", name: "UpdateCompanyInput!" },
  ]);

  const q = mutation({
    operation: "result: updateCompany",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function createCompany(input: CreateCompanyInput) {
  const _variables: CreateCompanyMutationVariables = {
    input,
  };

  const variables = buildVariables<CreateCompanyMutationVariables>(_variables, [
    { key: "input", name: "CreateCompanyInput!" },
  ]);

  const q = mutation({
    operation: "result: createCompany",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function registerCompanyAccount(userInput: CreateUserInput) {
  userInput.type = UserType.ADMINISTRATOR;
  const op: any = createUserOperation(userInput);
  const query: any = {
    ...op,
    authMode: "AWS_IAM",
  };
  return API.graphql(query);
}

function requestJoinCompanyOperation(input: CreateRequestJoinCompanyInput) {
  const _variables: CreateRequestJoinCompanyMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateRequestJoinCompanyMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateRequestJoinCompanyInput!" }]
  );
  return mutation({
    operation: "result: createRequestJoinCompany",
    fields: ["id"],
    variables,
  });
}
export function listRequestJoinCompany(companyID: string, userFields: any[]) {
  const _variables: ListRequestJoinCompanyByCompanyIDQueryVariables = {
    companyID,
    filter: {
      status: { eq: RequestJoinCompanyStatus.PENDING },
    },
  };
  const variables =
    buildVariables<ListRequestJoinCompanyByCompanyIDQueryVariables>(
      _variables,
      [
        { key: "companyID", name: "ID!" },
        { key: "filter", name: "ModelRequestJoinCompanyFilterInput" },
      ]
    );
  const q = query({
    operation: "result: listRequestJoinCompanyByCompanyID",
    fields: [{ items: ["id", { user: userFields }] }],
    variables,
  });
  return API.graphql(q);
}

function updateStatusRequestJoinCompany(
  requestID: string,
  status: RequestJoinCompanyStatus
) {
  const _variables: UpdateRequestJoinCompanyMutationVariables = {
    input: {
      id: requestID,
      status,
    },
  };
  const variables = buildVariables<UpdateRequestJoinCompanyMutationVariables>(
    _variables,
    [{ key: "input", name: "UpdateRequestJoinCompanyInput!" }]
  );
  const q = mutation({
    operation: "result: updateRequestJoinCompany",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

function getRequestJoinCompany(requestID) {
  const _variables: GetRequestJoinCompanyQueryVariables = {
    id: requestID,
  };
  const variables = buildVariables<GetRequestJoinCompanyQueryVariables>(
    _variables,
    [{ key: "id", name: "ID!" }]
  );
  const q = query({
    operation: "result: getRequestJoinCompany",
    fields: ["companyID", { user: ["id", "username"] }],
    variables,
  });
  return API.graphql(q);
}

export async function approveRequestJoinCompany(requestID: string) {
  const request: any = await getRequestJoinCompany(requestID);
  const { companyID, user } = request.data?.result;
  const admin: any = await listCompanyUsers(companyID, CompanyRole.ADMIN);
  const { adminID } = admin.data?.result?.items[0];
  const { username, id: userID } = user;

  await createCompanyRole({
    id: userID,
    userID,
    owner: username,
    username,
    companyID,
    adminID,
    role: CompanyRole.EMPLOYEE,
  });
  return updateStatusRequestJoinCompany(
    requestID,
    RequestJoinCompanyStatus.APPROVED
  );
}

export function denyRequestJoinCompany(requestID: string) {
  return updateStatusRequestJoinCompany(
    requestID,
    RequestJoinCompanyStatus.REJECTED
  );
}

export async function requestJoinCompany(
  omitInput: Omit<CreateRequestJoinCompanyInput, "status">
) {
  const input: CreateRequestJoinCompanyInput = {
    userID: omitInput.userID,
    companyID: omitInput.companyID,
    status: RequestJoinCompanyStatus.PENDING,
  };
  const op: any = requestJoinCompanyOperation(input);
  return API.graphql(op);
}

export async function registerIndividualUser(
  fields: any[],
  _variables: CreateUserMutationVariables
) {
  if (!_variables.input) throw new Error("Invalid input.");

  let { username, email } = _variables.input;

  if (_variables.input) _variables.input.type = UserType.INDIVIDUAL;
  if (_variables.input) _variables.input.owner = username;
  const query: any = {
    ...createUserQuery(fields, _variables),
    authMode: "AWS_IAM",
  };
  const user = API.graphql(query);
  return user;
}

export async function updateUser(
  id: string,
  input: Omit<UpdateUserInput, "id">
) {
  const ops = updateUserOperation({
    ...input,
    id,
  });
  return API.graphql(ops);
}

export function updateUserOperation(input: UpdateUserInput) {
  const fields = ["id"];
  const _variables: UpdateUserMutationVariables = {
    input,
  };
  const variables = buildVariables<UpdateUserMutationVariables>(_variables, [
    { key: "input", name: "UpdateUserInput!" },
  ]);
  return mutation({
    operation: "result: updateUser",
    fields,
    variables,
  });
}

export async function updateUserByEmail(
  fields: any[],
  email: string,
  userInput: UpdateUserInput
) {
  const _variables: UpdateUserMutationVariables = {
    input: userInput,
    condition: { email: { eq: email } },
  };
  const query = updateUserQuery(fields, _variables);
  await API.graphql(query);
}

export async function updateUserByUsername(
  fields: any[],
  username: string,
  userInput: UpdateUserInput
) {
  const _variables: UpdateUserMutationVariables = {
    input: userInput,
    condition: { username: { eq: username } },
  };
  const query = updateUserQuery(fields, _variables);
  await API.graphql(query);
}

export function createUserQuery(
  fields: any[],
  _variables: CreateUserMutationVariables
) {
  const variables = buildVariables<CreateUserMutationVariables>(_variables, [
    { key: "input", name: "CreateUserInput!" },
    { key: "condition", name: "ModelUserConditionInput" },
  ]);
  return mutation({
    operation: "result: createUser",
    fields,
    variables,
  });
}

export function getUserByID(fields: any[], id: string) {
  const _variables: GetUserQueryVariables = {
    id,
  };
  const variables = buildVariables<GetUserQueryVariables>(_variables, [
    { key: "id", name: "ID!" },
  ]);

  const q = query({
    operation: "result: getUser",
    fields,
    variables,
  });
  return API.graphql(q);
}

export function getUserByUsernameQuery(
  fields: any[],
  _variables: GetUserByUsernameQueryVariables
) {
  const variables = buildVariables<GetUserByUsernameQueryVariables>(
    _variables,
    []
  );

  return query({
    operation: "result: getUserByUsername",
    fields,
    variables,
  });
}

export function getUserByEmailQuery(
  fields: any[],
  _variables: ByEmailQueryVariables
) {
  const variables = buildVariables<ByEmailQueryVariables>(_variables, []);

  return query({
    operation: "result: byEmail",
    fields,
    variables,
  });
}

export function updateUserQuery(
  fields: any[],
  _variables: UpdateUserMutationVariables
) {
  const variables = buildVariables<UpdateUserMutationVariables>(_variables, [
    { key: "input", name: "UpdateUserInput!" },
    { key: "condition", name: "ModelUserConditionInput" },
    { key: "email", name: "ModelStringInput" },
    { key: "username", name: "ModelStringInput" },
  ]);

  return mutation({
    operation: "result: updateUser",
    fields,
    variables,
  });
}

export function listUsers(fields: any[], _variables?: ListUsersQueryVariables) {
  if (!_variables) {
    _variables = {};
  }

  const variables = buildVariables<ListUsersQueryVariables>(_variables, [
    { key: "filter", name: "ModelUserFilterInput!" },
    { key: "limit", name: "Int" },
  ]);

  const q = query({
    operation: "result: listUsers",
    fields,
    variables,
  });
  return API.graphql(q);
}


export function getGuest( timestamp?: string) {
  const fields = [];
  const variables = buildVariables<GetGuestMutationVariables>(
    {
      input: {
        timestamp,
      },
    },
    [
      { key: "input", name: "GetGuest" },
    ]
  );

  let q = mutation({
    operation: "result: getGuest",
    fields,
    variables,
  });
  q = Object.assign(q, { authMode: "AWS_IAM" });
  return API.graphql(q);
}

export async function getGuestData(timestamp?: string) {
  return (await getGuest(timestamp) as GraphQLResult<{ result: any }>).data?.result
}
